import { AppState } from '../../bootstrap/redux/state/AppState';

export function selectPersonalSpace(state: AppState) {
  return state.personalSpace;
}
